/* eslint-disable camelcase */
import PropTypes from 'prop-types';

import { propTypesIllustration } from '../../../constants/Proptypes';

const propTypesSliceQuestionsType = {
  questions_type_title: PropTypes.string,
};

const propTypesItemsQuestionsType = {
  questions_type_card_title: PropTypes.string,
  questions_type_card_illustration: propTypesIllustration,
};

export const propTypesDataQuestionsType = {
  id: PropTypes.string,
  slice_type: PropTypes.string,
  slice_label: PropTypes.string,
  primary: PropTypes.shape(propTypesSliceQuestionsType),
  items: PropTypes.arrayOf(PropTypes.shape(propTypesItemsQuestionsType)),
};
